import { useEffect, useState } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { Award } from "lucide-react";
import api from "@/lib/api";

export default function Certifications() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Certifications | Labpronics Technologies";
    api.get("/content/certifications").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <Layout>
      <PageHero eyebrow="Accreditations" title="Certifications & Compliance" subtitle="Our quality, service-management and information-security certifications underpin every government and enterprise engagement." image="/generated/forensics.jpg" />
      <section className="py-20">
        <div className="container-lp grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c, i) => (
            <Reveal key={c.id} delay={(i % 3) * 0.07}>
              <div className="bg-white border border-lp-border rounded-sm p-8 flex items-center gap-5 hover:border-lp-cyan transition-colors">
                {c.image ? <img src={c.image} alt={c.name} className="h-14 w-14 object-contain" /> : <div className="h-14 w-14 bg-lp-grey rounded-sm flex items-center justify-center"><Award size={28} className="text-lp-cyan" /></div>}
                <div>
                  <div className="font-heading font-700 text-lp-blue text-lg">{c.name}</div>
                  {c.description && <div className="text-sm text-lp-muted mt-1">{c.description}</div>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </Layout>
  );
}
